import {useState} from 'react';

export const getPaginationConfig = (page = 1, pageSize = 10) => ({
    page,
    pageSize
});


export default ({pagination = getPaginationConfig(), search = {}, sort = {}} = {}) => {
    const [searchData, setSearchData] = useState({pagination, search, sort});
    const [totalCount, setTotalCount] = useState(0);
    const [contractorTotalCount, setContractorTotalCount] = useState(0);
    const setPaginationConfig = (config) => {
        setSearchData(searchData => ({...searchData, pagination: config}))
    };
    const setSearchConfig = (search, preservePagination) => {
        setSearchData(searchData => ({...searchData, pagination: preservePagination ? searchData.pagination : {...searchData.pagination, page: 1}, search: search}))
    };
    const setSortConfig = (sort) => {
        setSearchData(searchData => ({...searchData, pagination: {...searchData.pagination, page: 1}, sort: sort}))
    };
    return {searchData, totalCount, setTotalCount, contractorTotalCount, setContractorTotalCount, setPaginationConfig, setSearchConfig, setSortConfig};
}

